import { render, staticRenderFns } from "./ProposedRepayment.vue?vue&type=template&id=289f82e3"
import script from "./ProposedRepayment.vue?vue&type=script&lang=js"
export * from "./ProposedRepayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports